import { ApiError } from '../api/client'

const COMPANY_ERROR_MESSAGES: Record<string, string> = {
  company_access_denied: 'Nie masz dostępu do wybranej spółki.',
}

export function companyErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const byCode = err.code ? COMPANY_ERROR_MESSAGES[err.code] : undefined
    if (byCode) return byCode
    const byMessage = COMPANY_ERROR_MESSAGES[err.message]
    if (byMessage) return byMessage
    return err.message
  }
  return 'Nie udało się wybrać spółki'
}
